import { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { PenLine, Trash2 } from 'lucide-react';

// `signature` is the File the parent holds; the pad derives its Clear state from it instead of tracking its own.
const SignaturePad = ({ signature, onSignature, title = 'Draw your signature' }) => {
  const canvasRef = useRef(null);

  const handleClear = () => {
    canvasRef.current.clear();
    onSignature(null);
  };

  const handleEnd = () => {
    if (canvasRef.current.isEmpty()) return;

    canvasRef.current.getCanvas().toBlob((blob) => {
      if (blob) onSignature(new File([blob], 'signature.png', { type: 'image/png' }));
    }, 'image/png');
  };

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
      <div className="flex items-center justify-between gap-3 border-b border-gray-100 bg-secondary-50/70 px-4 py-3">
        <span className="flex min-w-0 items-center gap-2">
          <PenLine size={15} strokeWidth={2.5} className="shrink-0 text-secondary-500" />
          <span className="truncate text-sm font-bold text-secondary-900">{title}</span>
        </span>

        <button
          type="button"
          onClick={handleClear}
          disabled={!signature}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg px-2.5 py-1 text-xs font-semibold text-rose-600 transition-colors hover:bg-rose-50 disabled:text-secondary-400 disabled:hover:bg-transparent"
        >
          <Trash2 size={13} /> Clear
        </button>
      </div>

      <SignatureCanvas
        ref={canvasRef}
        penColor="#0f172a"
        clearOnResize={false}
        canvasProps={{ className: 'block h-40 w-full cursor-crosshair' }}
        onEnd={handleEnd}
      />

      <p className="border-t border-gray-100 px-4 py-2 text-xs text-secondary-400">Use your finger or mouse to sign inside the box.</p>
    </div>
  );
};

export default SignaturePad;
